












































































import { COLLECTION_ROLES, COLLECTION_USERS } from '@/model/AppConstants';
import { Vue, Component } from 'vue-property-decorator';
import FirebaseUtil from '@/model/FirebaseUtil';

@Component({
  components: {},
})
export default class Settings extends Vue {
  role = {} as any;

  dialog = false;

  dialogDelete = false;

  deletedItem = {} as any;

  deleteIndex = '';

  headers = [
    {
      text: 'Code',
      align: 'start',
      value: 'roleType.code',
    },
    { text: 'Name', value: 'roleType.name' },
    { text: 'Description', value: 'roleType.description' },
    { text: 'Actions', value: 'actions' },
  ];

  mounted() {
    this.$store.dispatch('bindRole');
  }

  deleteItem(item: any) {
    this.deleteIndex = this.user.roles.indexOf(item);
    this.dialogDelete = true;
  }

  deleteItemConfirm() {
    const cloneObj = { ...this.user };
    cloneObj.roles.splice(this.deleteIndex, 1);
    const roleList = [] as any;
    cloneObj.roles.forEach((roleObj: any) => {
      const roleRef = FirebaseUtil.ObjectToRef(COLLECTION_ROLES, roleObj.id);
      roleList.push(roleRef);
    });
    cloneObj.roles = roleList;
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_USERS,
      doc: cloneObj.uid,
      payload: { ...cloneObj },
    });
    this.dialogDelete = false;
  }

  close() {
    this.dialog = false;
  }

  closeDelete() {
    this.dialogDelete = false;
  }

  get parsedUser() {
    const cloneObj = { ...this.user };
    const ref = FirebaseUtil.ObjectToRef(COLLECTION_ROLES, this.role.id);
    const roleList = [] as any;
    this.user.roles.forEach((roleObj: any) => {
      const roleRef = FirebaseUtil.ObjectToRef(COLLECTION_ROLES, roleObj.id);
      roleList.push(roleRef);
    });
    cloneObj.roles = roleList;
    cloneObj.roles.push(ref);
    return cloneObj;
  }

  assign() {
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_USERS,
      doc: this.user.uid,
      payload: { ...this.parsedUser },
    });
    this.role = {};
    this.dialog = false;
  }

  get roles() {
    return this.$store.state.roles;
  }

  get user() {
    // const userObj = ;
    return this.$store.state.profileUser;
  }
}
